import { createFileRoute } from '@tanstack/react-router';
import { RecurringServiceEventsQueue } from '@/components/organisms/memberships/RecurringServiceEventsQueue';

/**
 * The Recurring Service Events queue (ServiceTitan parity) — a flat, filterable
 * list of the membership visits owed, each bookable into a scheduled $0 job.
 */
function MembershipVisitsPage() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="border-b px-5 pb-3 pt-4 sm:px-7">
        <h1 className="text-lg font-semibold leading-tight tracking-[-0.01em] text-foreground">
          Recurring Service Events
        </h1>
      </div>
      <div className="min-h-0 flex-1">
        <RecurringServiceEventsQueue />
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_dashboard/dashboard/membership-visits')({
  component: MembershipVisitsPage,
});
